const styles = {
	container: {
		position: 'fixed',
		top: '50px',
		left: '0',
		// float: 'left',
		padding: '0',
		// marginRight: '-300px',
		width: '350px',
		height: 'calc(100% - 130px)',
		zIndex: 100,
	},
	leftCol: {
		// boxShadow: '2px 0 18px rgba(0, 0, 0, 0.26)',
	},
	rightCol: {
		position: 'relative',
		left: '-12px',
		border: '1px solid #b5b5b5',
		// display: 'flex',
		// flexDirection: 'column',
		// borderRadius: '10px',
		boxShadow: '2px 0 18px rgba(0, 0, 0, 0.26)',
		paddingTop: '20px',
		paddingBottom: '20px',
		height: 'calc(100% - 150px)',
		maxHeight: 'calc(100% - 200px)',
		overflowY: 'auto',
		backgroundColor: '#f7f7f7',
		opacity: 1,
		width: '100%',
		transition: 'opacity 0.3s ease-in-out, width 0.5s ease-in-out',
	},
	rightColInnerContainer: {
		// display: 'flex',
		// flexDirection: 'column',
		// maxHeight: 'calc(100% - 150px)',
		// overflowY: 'auto',
	},
	hidden: {
		width: '0%',
		opacity: 0,
	},
	toolBarBtn: {
		borderRadius: '0',
	},
	textNoWrap: {
		display: 'inline-block',
		width: '220px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	header: {
		marginTop: '10px',
		marginBottom: '10px',
	},
	headerLabel: {
		marginRight: '15px',
	},
	headerTextLine: {
		paddingTop: '10px',
		paddingLeft: '10px',
	},
	headerTextLineSpanBox: {
		// width: '130px',
	},
	rtlDirection: {
		direction: 'rtl',
	},
	placeholder: {},
	placeholderHeader: {},
	placeholderLine: {},
};

export default styles;
